(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme') || "";
		this.isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();

		if (this.isLightLogo == 'true')
			this.header.classList.add('header--light-logo');
		else 
			this.header.classList.remove('header--light-logo');
	}

	disableScroll() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	enableScroll() {
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		
		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					/*if (this.colorScheme)
						this.header.classList.remove(this.colorScheme);*/
					this.header.classList.forEach(className => {
						if (className.startsWith('color-background-') && className != 'color-background-overlay') {
							this.header.classList.remove(className);
						}
					});
					this.header.classList.add('shopify-section-header-scroll');
					this.header.classList.add('color-background-overlay-hidden');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					if (this.colorScheme)
						this.header.classList.add(this.colorScheme);	
					this.header.classList.remove('shopify-section-header-scroll');
					this.header.classList.remove('color-background-overlay-hidden');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			/*if (this.colorScheme)
				this.header.classList.remove(this.colorScheme);*/
			this.header.classList.forEach(className => {
				if (className.startsWith('color-background-') && className != 'color-background-overlay') {
					this.header.classList.remove(className);
				}
			});
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		if (this.headerIsAlwaysSticky) {
			this.header.classList.remove('shopify-section-header-scroll')
			return;
		}
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			if (this.colorScheme)
				this.header.classList.add(this.colorScheme);
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["malichus-watch-finder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-malichus-finder]').forEach(function(root) {
  var form = root.querySelector('[data-finder-form]');
  var result = root.querySelector('[data-finder-result]');
  var configNode = root.querySelector('[data-finder-config]');
  if (!form || !result || !configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (e) { return; }

  form.addEventListener('submit', function(event) {
    event.preventDefault();
    var data = new FormData(form);
    var budget = data.get('budget');
    var character = data.get('character');
    var display = data.get('display');
    var use = data.get('use');
    var wrist = data.get('wrist');
    var route = 'independent';

    if (budget === 'under500') route = 'discovery';
    else if (budget === 'mid') route = 'independent';
    else if (display === 'orbital' || wrist === 'small') route = 'mars';
    else if (display === 'wandering' && character === 'technical') route = 'manta';
    else if (display === 'wandering') route = 'tarantula';
    else if (character === 'technical') route = 'manta';
    else if (use === 'collector') route = 'collector';
    else route = 'collector';

    root.querySelector('[data-result-title]').textContent = config.copy[route].title;
    root.querySelector('[data-result-description]').textContent = config.copy[route].description;
    root.querySelector('[data-result-link]').setAttribute('href', config.routes[route]);
    result.hidden = false;
    result.scrollIntoView({behavior: 'smooth', block: 'nearest'});
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mz-encyclopedia-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  function destination(action,query,scope,lang,current){
    const url=new URL(action,current);
    const sections=['timeline','brands','ideas','precision','people','learn','makers','dictionary'];
    const tab=sections.includes(scope)?scope:'timeline';
    if(sections.includes(scope)&&scope!=='makers'&&scope!=='dictionary')url.searchParams.set('search_scope',scope);
    url.searchParams.set('lang',lang==='ar'?'ar':'en');
    url.searchParams.set('tab',tab);
    if(query.trim())url.searchParams.set(scope==='makers'?'mk_q':scope==='dictionary'?'dict_q':'search',query.trim().slice(0,160));
    const preview=new URL(current).searchParams.get('preview_theme_id');
    if(preview)url.searchParams.set('preview_theme_id',preview);
    return url;
  }
  function init(){
    document.querySelectorAll('[data-mzp-home]').forEach(root=>{
      if(root.dataset.mzpBound)return;
      root.dataset.mzpBound='1';
      const form=root.querySelector('[data-mzp-search]');
      const preview=new URL(location.href).searchParams.get('preview_theme_id');
      if(preview){
        const hidden=document.createElement('input');hidden.type='hidden';hidden.name='preview_theme_id';hidden.value=preview;form.appendChild(hidden);
        root.querySelectorAll('[data-mzp-entry]').forEach(a=>{const url=new URL(a.href,location.href);url.searchParams.set('preview_theme_id',preview);a.href=url.href});
      }
      form.addEventListener('submit',event=>{event.preventDefault();const query=form.querySelector('[name="search"]').value,scope=form.querySelector('[name="scope"]').value;location.assign(destination(form.action,query,scope,root.lang,location.href).href)});
    });
  }
  init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
